import React from 'react';
import {
  MdDashboard,
  MdOutlineAttachMoney,
  MdPendingActions,
  MdPermMedia,
  MdSource,
} from 'react-icons/md';
import { Header } from '../../../../components/singleComponents/headers/index';
import { Tab } from '../../../../components/singleComponents/tabs/index';
import { RootStyled } from './ConstructionsDetails.styles';

const headings = [
  {
    title: 'Lançamentos',
    icon: <MdSource size={18} />,
    value: 'payables',
    id: 'payables-tab',
  },
  {
    title: 'Orçamentos',
    icon: <MdOutlineAttachMoney size={18} />,
    value: 'budgets',
    id: 'budgets-tab',
  },
  {
    title: 'Cronograma',
    icon: <MdPendingActions size={18} />,
    value: 'schedules',
    id: 'schedules-tab',
  },
  {
    title: 'Fotos',
    icon: <MdPermMedia size={18} />,
    value: 'photos',
    id: 'photos-tab',
  },
  {
    title: 'Documentos',
    icon: <MdSource size={18} />,
    value: 'documents',
    id: 'documents-tab',
  },
  {
    title: 'Dashboard',
    icon: <MdDashboard size={18} />,
    value: 'dashboard',
    id: 'dashboard-tab',
  },
];

export function ConstructionsDetails() {
  return (
    <>
      <Header />
      <RootStyled>
        <Tab headingTab={headings} />
      </RootStyled>
    </>
  );
}
